import { tss } from 'tss-react/mui';

import { ListItemAvatar, ListItemText, Typography } from '@mui/material';

import type { GenericEventGovernanceVisitFieldsFragment as GovernanceVisit } from '@/gql/graphql';
import { GroupOrServiceAvatar } from '@/components/Avatar/GroupOrServiceAvatar';
import { Or2ListItem } from '@/components/data-display/Or2ListItem';

const useStyles = tss.create(({ theme }) => {
  return {
    // remove 56px minWidth of avatar list item
    eventAvatarRoot: {
      minWidth: 0,
    },
    timeText: { marginLeft: theme.spacing(2) },
  };
});

interface Props {
  visit: GovernanceVisit;
  showOwner: boolean;
}

export const GovernanceVisitListItem = ({ visit, showOwner }: Props) => {
  const { classes } = useStyles();
  const { owner, focus } = visit;

  return (
    <>
      <Typography
        component="span"
        className={classes.timeText}
        variant="caption"
        color="textSecondary"
      >
        All day
      </Typography>

      <Or2ListItem alignItems="flex-start" hoverHighlight={false}>
        {showOwner && (
          <ListItemAvatar className={classes.eventAvatarRoot}>
            <GroupOrServiceAvatar
              iconUrl={owner?.iconUrl}
              groupOrServiceName={owner?.name}
              sx={{ minWidth: 0, marginRight: 1.5 }}
            />
          </ListItemAvatar>
        )}

        <ListItemText
          disableTypography
          primary={<Typography variant="body2">Visit: {focus}</Typography>}
          secondary={
            showOwner && (
              <Typography
                component="span"
                variant="caption"
                color="textSecondary"
              >
                from {owner?.name}
              </Typography>
            )
          }
        />
      </Or2ListItem>
    </>
  );
};
